/* eslint-disable array-callback-return */
/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import { Space, Row, Col, Image } from "antd";
import { Button, FormControl, RadioGroup, FormControlLabel, Radio, TextField } from "@mui/material";
import crudActions from "../../../../CRUD/redux/actions";
import { NavLink } from "react-router-dom";
// import GridView from "./GridView";
import GridViewNew from "./GridViewNew";
import usePrevious from "../../../../Shared/components/Previous";
import { useSelector } from "react-redux";
import { SelectedIcon, UnSelectedIcon } from "../../../../Shared/components/Icons/selectedIcon";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import { scrollToError, storageSetItem, checkProductSearch, checkBillProductView, idNamingConversion } from "../../../../../helpers/utilities";
import { toast } from 'react-toastify';
import { BillLineForm } from "./Blocks/BillLineForm";
import { emptyValidation, customNumberValidation, customNumberValidationQuantity } from "../../../../../helpers/validation";
import unitActions from "../../../../Product/Setup/redux/actions";
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { getRequest } from '../../../../../helpers/axiosClient';


export default function CustomerProducts(props) {
    const { visible, handleClose, clsx, classes, dispatch, productPrices, lines, locationApi, productGstdetails, order, locationDetails,
        unitMesurementdetails, customObject, hsnApi, viewType, hsnDetails, customerDetail, businessDetails, gstCalculation,
        customerId, creditNote, includeGst, productActions, lineSubmit, handleMyProductsLoad, extraClass, priceIncludesTax, quote } = props;
    const { getList, getData } = useSelector(state => state.crudReducer);
    const { parameterDetails } = useSelector(state => state.homeReducer);
    const { productGroupDetails } = useSelector(state => state.productSetupReducer);
    const [productId, setProductId] = useState('');
    const [productGroupId, setProductGroupId] = useState('');
    const [priceList, setPriceList] = useState([]);
    const [skip, setSkip] = useState(0);
    const limit = 100;
    const [selected, setSelected] = useState([]);
    const [stockLoading, setStockLoading] = useState(false);
    const [type, setType] = useState(viewType ? viewType : 'customerProducts');
    const [customerProducts, setCustomerProducts] = useState(false);
    const [lineStock, setLineStock] = useState([]);
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const priceRef = useRef(null);
    const [changeSelected, setChangeSelected] = useState(false);
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);
    const [formVisible, setFormVisible] = useState(false);
    const [lineForm, setLineForm] = useState({});
    const [lineError, setLineError] = useState({});
    const [errorLineForm, setErrorLineForm] = useState({});
    const [viewBatch, setViewBatch] = useState(false);
    const [batch, setBatch] = useState([]);
    const [, setBatchDetails] = useState([]);
    const [autoMark, setAutoMark] = useState(false);
    const [selectedBatchId, setSelectedBatchId] = useState([]);
    const [availableQuantity, setAvailableQuantity] = useState({});
    const [showNameDesc, setShowNameDesc] = useState(checkBillProductView());
    const [units, setUnits] = useState([]);
    const [freeProduct, setFreeProduct] = useState({});
    const [freeAvailableQuantity, setFreeAvailableQuantity] = useState({});
    const [selectedFreeBatchId, setSelectedFreeBatchId] = useState([]);
    const [freeBatch, setFreeBatch] = useState([]);
    const [showFreeProduct, setShowFreeProduct] = useState(false);
    const [triggerLineSubmit, setTriggerLineSubmit] = useState(false);

    useEffect(() => {
        if (visible) {
            dispatchFilter(type);
            locationApi();
            dispatch({
                type: unitActions.PRODUCT_GROUP_DETAILS_START, url: 'product-groups', filter: {
                    order: 'id desc'
                }
            });
        }
    }, [visible]);

    useEffect(async () => {
        if (lines.length) {
            const filteredLines = lines.filter(el => el.parentLineNumber == null || el.parentLineNumber === "");
            setLineForm(calculateLineTotal({
                ...filteredLines[filteredLines.length - 1],
                quantity: parseFloat(filteredLines[filteredLines.length - 1].quantity)
            }));
            // setLineForm({
            //     ...filteredLines[filteredLines.length - 1],
            //     quantity: parseFloat(filteredLines[filteredLines.length - 1].quantity)
            // });
            if (parameterDetails?.inventoryTransaction) {
                setTimeout(() => {
                    handleProductBatchDetails(filteredLines[filteredLines.length - 1], lines);
                    handleUnits(filteredLines[filteredLines.length - 1]?.product);
                    handleStockUnits(filteredLines[filteredLines.length - 1].productId,
                        filteredLines[filteredLines.length - 1].unitId,
                        filteredLines[filteredLines.length - 1].quantity);
                }, 500)
            } else {
                setSelected(lines);
            }
            if (productActions) {
                let d = filteredLines[filteredLines.length - 1];
                if (d?.hsnId) {
                    hsnApi('', d.hsnId);
                }
            }
            setChangeSelected(!changeSelected);
        } else {
            setLineForm({});
        }
    }, [lines]);


    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }

        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {

                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    useEffect(() => {
        if (loadMore && getList.length === 0 && type === 'customerProducts') {
            setCustomerProducts(true);
            handleTypeChange('myProducts');
        }
    }, [getList, loadMore]);

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 0 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(type, productGroupId);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(type, productGroupId);
                }, 500);
            }
        }
    }, [search]);


    const dispatchFilter = (type, productGroupId = '', skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        if (handleMyProductsLoad) {
            handleMyProductsLoad();
        }

        let filter = { ["and"]: [{ status: 'ACTIVE' }, { ["or"]: [{ transType: { eq: null } }, { transType: { eq: 'SALES' } }] }] };

        if (productGroupId) {
            filter['and'].push({ productGroupId: productGroupId });
        }

        let or = { ["or"]: [] };
        // if (search !== '') {
        //     or['or'].push({ productName: { like: '%' + search.trim() + '%' } });
        //     or['or'].push({ productId: { like: '%' + search.trim() + '%' } });
        //     or['or'].push({ description: { like: '%' + search.trim() + '%' } });
        //     or['or'].push({ type: { like: '%' + search.trim() + '%' } });
        //     or['or'].push({ code: { like: '%' + search.trim() + '%' } });
        //     or['or'].push({ barcode: { like: '%' + search.trim() + '%' } });
        // }

        let array = ['productName', 'productId', 'description', 'type', 'barcode', 'code'];
        if (search !== '') {
            if (checkProductSearch() === 'both') {
                array = ['productName', 'code'];
            } else if (checkProductSearch() === 'name') {
                array = ['productName'];
            } else if (checkProductSearch() === 'code') {
                array = ['code'];
            } else if (checkProductSearch() === 'mrp') {
                array = ['mrp'];
            }
            array.map((el) => {
                if (el === 'code' || el === 'mrp') {
                    return or['or'].push({ [el]: search.trim() })
                } else {
                    return or['or'].push({ [el]: { like: '%' + search.trim() + '%' } })
                }
            });
        }

        if (or.or.length > 0) {
            filter['and'].push(or);
        }
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: type === 'customerProducts' ? `v1/schedules/customer-products` : `client-products`,
            skip: skip,
            filter: {
                where: type === 'customerProducts' ? { 'customerId': customerId, status: 'ACTIVE' } : filter,
                order: 'id desc',
                limit: limit,
                skip: skip,
            }
        });
    }

    useEffect(() => {
        if (productPrices && productPrices !== '' && productId !== '') {
            let selectedIndex = priceList?.findIndex(el => el.productId === productId);
            if (selectedIndex >= 0) {
                setPriceList(prevState => {
                    return prevState?.filter((value, i) => i !== selectedIndex)
                });
            } else {
                let data = {
                    productId: productId,
                    data: productPrices
                };
                setPriceList((prevState) => {
                    return [...prevState, data];
                });
            }
            // if (productId === 'single') {
            //     handleSinglePrice(lineForm, productPrices);
            // } else {
            //     handlePrice(productId, productPrices, selected);
            // }
            handleSinglePrice(lineForm, productPrices);
            handlePrice(productId, productPrices, selected);
            setProductId('');

        }

    }, [productPrices]);

    const handleSinglePrice = (lineForm, prices) => {
        let pricePerUnit = 0; let mrp = 0; let excisesSplRate = 0; let discountRate = 0; let discount = 0; let discountAmount = 0; let useMrp = false;
        if (parameterDetails?.aggrementSalesPrice && prices?.priceagreement &&
            Object.keys(prices?.priceagreement).length > 0 &&
            prices?.priceagreement[customObject(unitMesurementdetails, lineForm?.unitId)?.name]) {
            let result = prices?.priceagreement[customObject(unitMesurementdetails, lineForm?.unitId)?.name][0];
            if (result?.price) {
                pricePerUnit = result?.price;
            }
            if (result?.specialExcisesDuty) {
                excisesSplRate = result?.specialExcisesDuty;
            }
            if (result?.mrp) {
                mrp = result?.mrp;
            }
            if (result?.isMrp) {
                useMrp = result?.isMrp;
            }
        } else {
            if (parameterDetails?.lastSalesPrice && prices?.lastprice && Object.keys(prices?.lastprice).length > 0 &&
                prices?.lastprice[customObject(unitMesurementdetails, lineForm?.unitId)?.name]) {
                let result = productPrices?.lastprice[customObject(unitMesurementdetails, lineForm?.unitId)?.name];
                if (result?.price) {
                    pricePerUnit = result?.price;
                }
                if (result?.mrp) {
                    mrp = result?.mrp;
                    useMrp = true;
                }
            }
        }

        if (prices?.discountagreement && Object.keys(prices?.discountagreement).length > 0 &&
            productPrices?.discountagreement[customObject(unitMesurementdetails, lineForm?.unitId)?.name]) {
            let result = productPrices?.discountagreement[customObject(unitMesurementdetails, lineForm?.unitId)?.name][0];
            if (parameterDetails?.discountRate) {
                discountRate = result?.price || '';
            } else {
                discountAmount = result?.price || '';
            }
            if (result?.percentage) {
                discount = result?.percentage || '';
            }
        } else if (prices?.lastdiscount && Object.keys(prices?.lastdiscount).length > 0 &&
            prices?.lastdiscount[customObject(unitMesurementdetails, lineForm?.unitId)?.name]) {
            discount = prices?.lastdiscount[customObject(unitMesurementdetails, lineForm?.unitId)?.name]?.percent;
            if (parameterDetails?.discountRate) {
                discountRate = prices?.lastdiscount[customObject(unitMesurementdetails, lineForm?.unitId)?.name]?.rate || '';
            } else {
                discountAmount = prices?.lastdiscount[customObject(unitMesurementdetails, lineForm?.unitId)?.name]?.amount || '';
            }
        }
        setLineForm({
            ...lineForm,
            'pricePerUnit': pricePerUnit || lineForm?.pricePerUnit || 0,
            'maxRetailPrice': mrp || lineForm?.maxRetailPrice || 0,
            'useMrp': useMrp,
            'excisesSplRate': excisesSplRate,
            'discountPercent': discount || 0, 'discountAmount': discountAmount || 0, 'discountRate': discountRate || 0
        });
    }


    const handlePrice = (id, prices, selected) => {
        let selectedFilter = selected?.filter(el => el.productId === id);
        if (selectedFilter && selectedFilter?.length > 0) {
            // if ((prices?.priceagreement && Object.keys(prices?.priceagreement).length > 0) ||
            //     (prices?.lastprice && Object.keys(prices?.lastprice).length > 0) ||
            //     (prices?.discountagreement && Object.keys(prices?.discountagreement).length > 0)) {
            let pricePerUnit = 0; let mrp = 0; let discount = 0; let excisesSplRate = 0; let discountAmount = 0;
            if (parameterDetails?.aggrementSalesPrice && prices?.priceagreement && Object.keys(prices?.priceagreement).length > 0 &&
                prices?.priceagreement[customObject(unitMesurementdetails, selectedFilter[0].unitId)?.name]) {
                let result = prices?.priceagreement[customObject(unitMesurementdetails, selectedFilter[0].unitId)?.name][0];
                if (result?.price) {
                    pricePerUnit = result?.price;
                }
                if (result?.specialExcisesDuty) {
                    excisesSplRate = result?.specialExcisesDuty;
                }
                if (result?.mrp) {
                    mrp = result?.mrp;
                }
            } else {
                if (parameterDetails?.lastSalesPrice && prices?.lastprice && Object.keys(prices?.lastprice).length > 0 &&
                    prices?.lastprice[customObject(unitMesurementdetails, selectedFilter[0].unitId)?.name]) {
                    let result = productPrices?.lastprice[customObject(unitMesurementdetails, selectedFilter[0].unitId)?.name];
                    if (result?.price) {
                        pricePerUnit = result?.price;
                    }
                    if (result?.mrp) {
                        mrp = result?.mrp;
                    }
                }
            }

            if (prices?.discountagreement && Object.keys(prices?.discountagreement).length > 0 &&
                productPrices?.discountagreement[customObject(unitMesurementdetails, selectedFilter[0].unitId)?.name]) {
                let result = productPrices?.discountagreement[customObject(unitMesurementdetails, selectedFilter[0].unitId)?.name][0];
                if (result?.price) {
                    discountAmount = result?.price || '';
                }
                if (result?.percentage) {
                    discount = result?.percentage || '';
                }
            } else if (prices?.lastdiscount && Object.keys(prices?.lastdiscount).length > 0 &&
                prices?.lastdiscount[customObject(unitMesurementdetails, selectedFilter[0].unitId)?.name]) {
                discount = prices?.lastdiscount[customObject(unitMesurementdetails, selectedFilter[0].unitId)?.name]?.percent;
            }

            const newTodos = selected.map((el) => {
                if (el.productId === id && (el.parentLineNumber == null || el.parentLineNumber === "")) {
                    return {
                        ...el, 'pricePerUnit': parseFloat(pricePerUnit || el?.pricePerUnit || 0), 'excisesSplRate': excisesSplRate, 'maxRetailPrice': mrp || el.maxRetailPrice || 0,
                        'discountPercent': discount, 'discountAmount': discountAmount
                    };
                }
                return el;
            });
            setSelected(newTodos);
            setChangeSelected(!changeSelected);
            // }
        }
    }

    useEffect(() => {
        if (selected && selected?.length > 0) {
            const newTodos = selected.map((el) => {
                return calculateLineTotal(el);
            });
            setSelected(newTodos);
            setLineForm(calculateLineTotal(lineForm));
        }
    }, [changeSelected]);


    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(type, productGroupId, s);
    }

    const calculateLineTotal = (el) => {
        let data = {
            cgst: '', sgst: '', igst: '', cgstPercentage: '', sgstPercentage: '', igstPercentage: ''
        };
        const amount = el.quantity * el.pricePerUnit;
        let dPAmount = 0;
        let dTotal = 0;
        let gAmount = 0;
        data['salesValue'] = amount;
        if (el.discountPercent !== '') {
            dPAmount = dTotal = parseFloat((amount * el.discountPercent) / 100);
        }

        let discountAmount = el.discountAmount || 0;
        const lineDiscountType = el.discountType || 'perUnit';
        if (lineDiscountType === 'perUnit') {
            const qty = parseFloat(el?.quantity || 0);
            const rate = parseFloat(el?.discountRate || 0);
            discountAmount = Math.abs(qty) * Math.abs(rate);
            data['discountAmount'] = discountAmount;
        }
        if (discountAmount && discountAmount !== '') {
            if (amount < 0) {
                dTotal = parseFloat(dPAmount) - parseFloat(discountAmount);
            } else {
                dTotal = parseFloat(dPAmount) + parseFloat(discountAmount);
            }
        }

        let tAmount = (amount - dTotal);
        data['amount'] = tAmount;

        if (el.productGstId && el.includeGst) {
            let gstDetails = productGstdetails?.filter((e) => { return e.id === el.productGstId });
            let percentage = gstDetails?.length > 0 ? gstDetails[0]?.percentage : 0;
            let details = {
                percentage: percentage,
                stateId: customerDetail?.stateId,
                lineAmount: tAmount || 0,
                priceIncludesTax: priceIncludesTax || false,
            };
            let gstCalc = gstCalculation(businessDetails, details, customerDetail);
            // data['cgstPercentage'] = parseFloat(gstCalc.cgst);
            // data['sgstPercentage'] = parseFloat(gstCalc.sgst);
            // data['igstPercentage'] = parseFloat(gstCalc.igst);
            // data['cgst'] = parseFloat(gstCalc.cgstAmount);
            // data['sgst'] = parseFloat(gstCalc.sgstAmount);
            // data['igst'] = parseFloat(gstCalc.igstAmount);
            gAmount = gstCalc.gAmount;
        }

        if (el?.excisesApplicable) {
            let excisesAmount = 0;
            let splExcisesAmount = 0;
            if (el?.excisesType === 'perUnit') {
                const qty = parseFloat(el?.quantity || 0);
                const rate = parseFloat(el?.excisesRate || 0);
                excisesAmount = Math.abs(qty) * Math.abs(rate);
                data['excisesAmount'] = excisesAmount;
            } else {
                excisesAmount = el?.excisesAmount;
            }
            if (el?.excisesSplType === 'perUnit') {
                const sQty = parseFloat(el?.quantity || 0);
                const sRate = parseFloat(el?.excisesSplRate || 0);
                splExcisesAmount = Math.abs(sQty) * Math.abs(sRate);
                data['excisesSplAmount'] = splExcisesAmount;
            } else {
                splExcisesAmount = el?.excisesSplAmount || '';
            }
            let excisesTotal = parseFloat(excisesAmount || 0) + parseFloat(splExcisesAmount || 0) + parseFloat(el?.excisesAddAmount || 0);
            // console.log(splExcisesAmount);
            // console.log(excisesTotal);
            data['excisesTotal'] = parseFloat(el?.quantity || 0) < 0 ? -excisesTotal : excisesTotal;
            data['totalCostPrice'] = parseFloat(el?.quantity || 0) < 0 ? -(excisesTotal - (tAmount || 0)) : (excisesTotal + (tAmount || 0));
        }

        let result = {
            ...el,
            ...data,
            gstAmount: parseFloat(gAmount),
            discountPercAmount: dPAmount,
            discountCalcAmount: dTotal
        };
        return result;
    }

    const handleStockUnits = (productId, unitId, quantity) => {
        if (productId && unitId && quantity) {
            setStockLoading(true);
            getRequest(`${process.env.REACT_APP_API_URL}/check-stock-units/?productId=${productId}&unitId=${unitId}&quantity=${quantity}`)
                .then(response => {
                    setLineStock(prev => ({
                        ...prev,
                        [productId]: response.data
                    }));
                    setStockLoading(false);
                }).catch(error => {
                    console.error("Error fetching data", error);
                    setStockLoading(false);
                });
        }
    }

    const checkLineForm = (lineForm) => {
        let emptyDescription = emptyValidation('Description', lineForm?.description);
        let emptyUnit = emptyValidation('Unit', lineForm?.unitId, 'dropDown');
        let emptyPrice = customNumberValidation('Price', lineForm?.pricePerUnit);
        let emptyQuantity = customNumberValidationQuantity('Quantity', lineForm?.quantity);
        let emptyAmount = emptyValidation('Line Amount', lineForm?.amount);
        let checkValidation = true;
        let emptyProductGst = emptyValidation('Product GST Code', lineForm?.productGstId, 'dropDown');
        let emptyHsn = emptyValidation('HSN', lineForm?.hsnId, 'dropDown');
        let ret = false;
        if ((lineForm?.includeGst && !emptyProductGst.isValid) || (lineForm?.includeGst && !emptyHsn.isValid)) {
            checkValidation = false;
        }

        let discountAgreeMents = true;
        let total = lineForm?.quantity * lineForm?.pricePerUnit;
        if (Math.abs(total) < Math.abs(lineForm?.discountCalcAmount)) {
            discountAgreeMents = false;
        }

        let batchDetails = [];
        if (selectedBatchId?.length > 0) {
            let seBatch = batch.filter(el => selectedBatchId.includes(el.id));
            seBatch && seBatch?.length > 0 && seBatch.map((el) => {
                batchDetails.push({
                    batchId: el.id,
                    batch: el,
                    quantity: el.soldQuantity,
                    discountAmount: el.discountAmount
                })
            })
        }

        let freeBatchDetails = [];
        if (freeProduct?.quantitySpec === 'MIX & MATCH' && selectedFreeBatchId?.length > 0) {
            let seBatch = freeBatch.filter(el => selectedFreeBatchId.includes(el.id));
            seBatch && seBatch?.length > 0 && seBatch.map((el) => {
                freeBatchDetails.push({
                    batchId: el.id,
                    batch: el,
                    quantity: el.soldQuantity,
                    discountAmount: el.discountAmount
                })
            })
        }

        let negativeQuantityCheck = { isValid: true, errors: '' };
        if (!parameterDetails?.negativeStock && parameterDetails?.inventoryTransaction) {
            let totalQty = selected.filter(l => l.productId === lineForm?.productId).reduce((sum, item) => sum + parseFloat(item.quantity || 0), 0);
            // console.log(totalQty);
            // totalQty = totalQty + Math.abs(lineForm?.quantity);
            let qty = availableQuantity[lineForm?.productId] - totalQty;
            if (qty < 0) {
                negativeQuantityCheck = { isValid: false, errors: 'There is no stocks available' }
            }

            if (freeProduct?.id && freeProduct?.quantitySpec === 'SAME ITEM') {
                let lQty = Math.abs(lineForm?.quantity) + Math.abs(freeProduct?.freeQty);
                let tQty = availableQuantity[lineForm?.productId] - Math.abs(lQty);

                if (tQty < 0) {
                    negativeQuantityCheck = { isValid: false, errors: 'No stock available for the free product.' }
                }
            }
        }

        let batchQuantityError = { isValid: true, errors: '' };
        if (batchDetails?.length > 0) {
            let batchQuantity = batchDetails?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.quantity || 0)), 0);
            if (batchQuantity !== parseFloat(lineForm?.quantity)) {
                batchQuantityError = { isValid: false, errors: 'Total Selected Batch quantity should equal Line Quantity' }
            }
        }

        let negativeFreeQuantityCheck = { isValid: true, errors: '' };
        if (freeProduct?.id && !parameterDetails?.negativeStock && parameterDetails?.inventoryTransaction) {
            let totalQty = selected.filter(l => l.productId === freeProduct?.freeItemId).reduce((sum, item) => sum + parseFloat(item.quantity || 0), 0);
            totalQty = totalQty + Math.abs(freeProduct?.freeQty);
            let qty = freeAvailableQuantity[lineForm?.productId] - totalQty;
            if (qty < 0) {
                negativeFreeQuantityCheck = { isValid: false, errors: 'No stock available for the free product.' }
            }
        }


        let freeBatchQuantityError = { isValid: true, errors: '' };
        if (freeBatchDetails?.length > 0) {
            let freeBatchQuantity = freeBatchDetails?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.quantity || 0)), 0);
            if (freeBatchQuantity !== parseFloat(freeProduct?.freeQty)) {
                freeBatchQuantityError = { isValid: false, errors: 'Total Selected Batch quantity should equal Free Line Quantity' }
            }
        }


        setLineError({});
        if (emptyDescription.isValid &&
            emptyUnit.isValid && discountAgreeMents && freeBatchQuantityError.isValid && negativeFreeQuantityCheck.isValid &&
            emptyPrice.isValid && emptyQuantity.isValid && emptyAmount.isValid && checkValidation && batchQuantityError.isValid &&
            negativeQuantityCheck.isValid
        ) {
            if (freeProduct?.id) {
                let code = Math.floor(1000 + Math.random() * 9000);
                const oldTodos = selected.map((el) => {
                    if (el.productId === lineForm.productId && (el.parentLineNumber == null || el.parentLineNumber === "")) {
                        return { ...el, 'freeProductLineNumber': code };
                    }
                    return el;
                });
                let newTodos = {
                    productId: freeProduct?.freeItem?.id,
                    description: freeProduct?.freeItem?.description || freeProduct?.freeItem?.productName || '',
                    quantity: parseFloat(freeProduct?.freeQty),
                    unitId: freeProduct?.freeUnitId,
                    pricePerUnit: 0,
                    amount: 0,
                    includeGst: false,
                    discountAmount: 0,
                    discountPercent: 0,
                    gstAmount: 0,
                    cgst: 0,
                    sgst: 0,
                    igst: 0,
                    cgstPercentage: 0,
                    igstPercentage: 0,
                    sgstPercentage: 0,
                    maxRetailPrice: 0,
                    locationId: lineForm?.locationId || '',
                    parentLineNumber: code
                };

                if (lineForm?.hsnId) {
                    newTodos["hsnId"] = lineForm?.hsnId;
                    newTodos["hsn"] = lineForm?.hsn;
                }
                if (lineForm?.productGstId) {
                    newTodos["productGstId"] = lineForm?.productGstId;
                    newTodos["productGst"] = lineForm?.productGst;
                }
                if (freeProduct?.quantitySpec === 'SAME ITEM' && freeProduct?.freeItem?.batchActivation) {
                    let freeBatch = batch.filter(item => (item.availableStock - item.soldQuantity) !== 0);
                    if (freeBatch?.length > 0) {
                        freeBatch = freeBatch.map(item => ({
                            ...item,
                            availableStock: item.availableStock - item.soldQuantity,
                            soldQuantity: 0
                        }));
                        let freeBatchIds = findCombination(freeBatch.filter(el => el.locationId === lineForm?.locationId), freeProduct?.freeQty).changedItems;
                        freeBatch = findCombination(freeBatch.filter(el => el.locationId === lineForm?.locationId), freeProduct?.freeQty).updatedItems;
                        if (freeBatchIds?.length > 0) {
                            let seBatch = freeBatch.filter(el => freeBatchIds.includes(el.id));
                            let freeBatchDetails = [];
                            seBatch && seBatch?.length > 0 && seBatch.map((el) => {
                                freeBatchDetails.push({
                                    batchId: el.id,
                                    batch: el,
                                    quantity: el.soldQuantity,
                                    discountAmount: el.discountAmount
                                })
                            });
                            if (freeBatchDetails?.length > 0) {
                                let freeBatchQuantity = freeBatchDetails?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.quantity || 0)), 0);
                                if (freeBatchQuantity !== parseFloat(freeProduct?.freeQty)) {
                                    toast.dismiss();
                                    toast.error('Insufficient stock for free item');
                                    return false;
                                }
                            }
                            newTodos['batchDetails'] = freeBatchDetails;
                        }
                    }
                } else {
                    if (selectedFreeBatchId?.length > 0) {
                        let seBatch = freeBatch.filter(el => selectedFreeBatchId.includes(el.id));
                        let freeBatchDetails = [];
                        seBatch && seBatch?.length > 0 && seBatch.map((el) => {
                            freeBatchDetails.push({
                                batchId: el.id,
                                batch: el,
                                quantity: el.soldQuantity,
                                discountAmount: el.discountAmount
                            })
                        })
                        newTodos['batchDetails'] = freeBatchDetails;
                    }
                }
                setSelected([...oldTodos, newTodos]);
            }
            ret = true;
            setFreeAvailableQuantity({});
            setSelectedFreeBatchId([]);
            setFreeBatch([]);
            setFreeProduct({});
            setErrorLineForm({});
            setShowFreeProduct(false);
        } else {
            setLineError({
                description: emptyDescription?.errors || false,
                unitId: emptyUnit?.errors || false,
                discountAgreeMents: !discountAgreeMents ? 'Discount amount is greater than Line amount, please correct it.' : false,
                pricePerUnit: emptyPrice?.errors || false,
                quantity: negativeQuantityCheck?.errors || emptyQuantity?.errors || freeAvailableQuantity?.errors || negativeFreeQuantityCheck?.errors || false,
                batchQuantity: batchQuantityError?.errors || '',
                productGstId: lineForm?.includeGst && emptyProductGst?.errors ? emptyProductGst?.errors : false,
                hsnId: lineForm?.includeGst && emptyHsn?.errors ? emptyHsn?.errors : false
            });
            setErrorLineForm(lineForm);
            ret = false;
        }

        return ret
    }

    const handleClick = async (data, dataPro) => {
        if (productActions && lineForm && lineForm?.productId === data?.id) {
            let selectedSIngleIndex = selected?.findIndex(el => el.productId === lineForm.productId && (el.parentLineNumber == null || el.parentLineNumber === ""));
            if (selectedSIngleIndex >= 0) {
                setErrorLineForm({});
                setSelected(prevState => {
                    prevState = prevState.filter(el => (el.parentLineNumber == null || el.parentLineNumber === ""));
                    setLineForm(prevState.filter((value, i) => i !== selectedSIngleIndex)[prevState.filter((value, i) => i !== selectedSIngleIndex).length - 1]);
                    if (productActions) {
                        let d = prevState.filter((value, i) => i !== selectedSIngleIndex)[prevState.filter((value, i) => i !== selectedSIngleIndex).length - 1];
                        if (d?.hsnId) {
                            hsnApi('', d.hsnId);
                        }
                    }
                    return prevState.filter((value, i) => i !== selectedSIngleIndex)
                });
                setLineError({});
            }
            return false;
        }

        if (productActions && lineForm?.productId && !checkLineForm(lineForm)) {
            toast.dismiss();
            toast.error('Please select value in the highlighted mandatory field');
            return false;
        }

        let selectedIndex = selected?.findIndex(el => el.productId === data.id && (el.parentLineNumber == null || el.parentLineNumber === ""));
        if (selectedIndex >= 0) {
            setSelected(prevState => {
                setLineForm(prevState.filter((value, i) => i !== selectedIndex)[prevState.filter((value, i) => i !== selectedIndex).length - 1]);
                if (productActions) {
                    let d = prevState.filter((value, i) => i !== selectedIndex)[prevState.filter((value, i) => i !== selectedIndex).length - 1];
                    if (d?.hsnId) {
                        hsnApi('', d.hsnId);
                    }
                }
                return prevState.filter((value, i) => i !== selectedIndex)
            });
        } else {
            let d = {
                'productId': data?.id,
                'product': data,
                'quantity': parseFloat(creditNote ? `-${dataPro?.quantity || 1}` : `${dataPro?.quantity || 1}`),
                'description': data?.description || data?.productName || '',
                'unitId': data?.defaultSalesUnitId || data.salesUnitId || '',
                'productUnitId': data?.defaultSalesUnitId || data.salesUnitId || '',
                'unit': data?.defaultSalesUnit || data?.salesUnit || '',
                'maxRetailPrice': parameterDetails?.productUnitPrice ? data?.mrp : 0,
                'pricePerUnit': parameterDetails?.productUnitPrice ? (data?.costPrice || 0) : 0,
                'gstAmount': 0,
                'amount': 0,
                'discountPercent': 0,
                'discountAmount': 0,
                'discountType': parameterDetails?.discountRate ? 'perUnit' : 'fixed',
                'discountRate': 0,
                'includeGst': includeGst,
                'productGstId': includeGst ? data?.productGstId : null,
                'productGst': includeGst ? data?.productGst : '',
                'hsnId': includeGst ? data?.hsnId : null,
                'hsn': includeGst ? data?.hsn : null,
                'useMrp': parameterDetails?.productUnitPrice ? (data?.useMrp || false) : false,
                'costPrice': data?.costPrice || '',
                'excisesApplicable': data.exciseApplicable || false
            };

            if (data.exciseApplicable) {
                d['includeGst'] = false;
                d['productGstId'] = '';
                d['productGst'] = '';
                d['excisesType'] = 'perUnit';
                d['excisesSplType'] = 'perUnit';
            }

            if (locationDetails && locationDetails?.length > 0) {
                let a = locationDetails?.filter(el => el.default);
                if (a?.length) {
                    d.locationId = a[0]?.id;
                } else {
                    d.locationId = locationDetails[0]?.id;
                }
            }
            setLineForm(calculateLineTotal(d));
            handleStockUnits(d?.productId, d?.unitId, Math.abs(d?.quantity));
            const lineTotal = calculateLineTotal(d);


            if (parameterDetails?.inventoryTransaction) {
                setSelected(prev => {
                    const updated = [...prev, lineTotal];
                    if (parameterDetails?.inventoryTransaction) {
                        handleUnits(data);
                        getProductBatch(lineTotal, updated).then(batch => {
                            getAvailableQty(
                                data?.id,
                                data?.salesUnitId,
                                d?.locationId,
                                batch,
                                false
                            );
                        });
                    }
                    return updated;
                });
            } else {
                setSelected((prevState) => {
                    return [...prevState, calculateLineTotal(d)];
                });
            }

            if (order) {
                d.changed = true;
            }

            if (productActions) {
                hsnApi('', data.hsnId);
            }

            if (includeGst && !data?.productGstId && !data.exciseApplicable) {
                if (productActions) {
                    setProductId('single');
                }
                setErrorLineForm({
                    ...calculateLineTotal(d)
                });
                setLineError({
                    productGstId: 'Please select/enter a valid value in Product GST Code',
                    hsnId: !d?.hsnId && 'Please select/enter a valid value in HSN'
                });
                setTimeout(() => {
                    scrollToError();
                    setTimeout(() => {
                        document.getElementById('DD-SSL-product-gst-code').focus();
                    }, 100);
                }, 100);
            } else {
                if (productActions) {
                    setProductId(data.id);
                }
            }

            // setSelected((prevState) => {
            //     return [...prevState, calculateLineTotal(d)];
            // });

            // setLineForm({ ...calculateLineTotal(d) });
            // checkFreeProduct(d?.productId, 1, d.locationId);
            checkFreeProduct(d?.productId, 1, d.locationId);
        }

        if (productActions) {
            setChangeSelected(!changeSelected);
            dispatch({
                type: productActions.PRODUCT_PRICE_START,
                url: `/saledprice/${customerId}/${data?.id}/${Math.abs(dataPro?.quantity || 1)}`
            });
        }


        // if (lineForm?.productId === data?.id) {
        //     let selectedSIngleIndex = selected?.findIndex(el => el.productId === lineForm.productId);
        //     if (selectedSIngleIndex >= 0) {
        //         setSelected(prevState => {
        //             setLineForm(prevState.filter((value, i) => i !== selectedSIngleIndex)[prevState.filter((value, i) => i !== selectedSIngleIndex).length - 1]);
        //             return prevState.filter((value, i) => i !== selectedSIngleIndex)
        //         });
        //         setLineError({});
        //     }
        //     return false;
        // } else {
        //     if (Object.keys(lineError)?.length > 0) {
        //         toast.dismiss();
        //         toast.error('Please select value in the highlighted mandatory field');
        //         return false;
        //     }
        // }

    };


    const checkFreeProduct = (productId, quantity, locationId) => {
        // let filter = { "and": [{ saleItemId: productId }] };
        // let or = { "or": [] };
        // filter['and'].push({ fromDate: { gte: moment().format('YYYY-MM-DD') } });
        // filter['and'].push({ toDate: { lte: moment().format('YYYY-MM-DD') } });
        // or['or'].push({ customerId: customerId });
        // if (customerDetails?.groupId)
        //     or['or'].push({ customerGroupId: customerDetails?.groupId });
        // filter['and'].push(or);
        // let p = productId;
        // setProductId('');
        if (!productActions || quote) return true;


        // filter = { where: filter, order: 'id desc' };
        getRequest(`${process.env.REACT_APP_API_URL}/sales-quantities-search/${customerId}/${productId}/${quantity}`)
            // getRequest(`${process.env.REACT_APP_API_URL}/sales-quantities/?filter=${encodeURIComponent(JSON.stringify(filter))}`)
            .then(async uResponse => {
                if (uResponse?.data && uResponse?.data?.length > 0) {
                    let datass = uResponse?.data[0];
                    datass.freeQty = Math.floor((quantity / datass.salesQty) * datass.freeQty);
                    setFreeProduct(datass || {});

                    const response = await getRequest(`${process.env.REACT_APP_API_URL}/stock-on-hands/byProduct/${datass?.freeItemId}/${datass?.freeUnitId}/${locationId}`);
                    const data = response.data;
                    // let val = [];
                    if (data?.length && data[0]?.units?.length) {
                        let qty = data[0]?.units.find(obj => obj.hasOwnProperty(datass?.freeUnitId))?.[datass?.freeUnitId];
                        setFreeAvailableQuantity(prev => {
                            return {
                                ...prev,
                                [datass?.freeItemId]: parseFloat(parseFloat(qty).toFixed(2))  // Append `filtered` array
                            };
                        });
                    } else {
                        setFreeAvailableQuantity(prev => {
                            return {
                                ...prev,
                                [datass?.freeItemId]: 0  // Append `filtered` array
                            };
                        });
                    }
                    if (datass?.quantitySpec === 'MIX & MATCH' && datass?.freeItem?.batchActivation) {
                        try {
                            let f = { where: { ["and"]: [{ productId: datass?.freeItem?.id }, { availableStock: { gt: 0 } }] } };

                            const response = await getRequest(`${process.env.REACT_APP_API_URL}/product-batch-numbers/byProduct/${datass?.freeItem?.id}?filter=${encodeURIComponent(JSON.stringify(f))}`);
                            const data = response.data;
                            let val = [];
                            if (data && data.length) {
                                val = data.map(item => ({
                                    ...item,
                                    availableStock: item.availableStock,
                                    fakeAvailableStock: item.availableStock,
                                    soldQuantity: 0,
                                    originalSoldQuantity: 0
                                }));
                            } else {
                                val = [];
                            }
                            setSelectedFreeBatchId(findCombination(val.filter(el => el.locationId === locationId), datass?.freeQty).changedItems);
                            setFreeBatch(findCombination(val.filter(el => el.locationId === locationId), datass?.freeQty).updatedItems);
                            // setProductId(p);
                            return val;
                        } catch (error) {
                            setFreeBatch([]);
                            return [];
                        }
                    }
                }
                else {
                    setFreeProduct({});
                }
            }).catch(error => {
                console.error("Error fetching data", error);
            });
    }


    const getProductBatch = async (res, selected) => {
        try {
            let f = { where: { ["and"]: [{ productId: res?.productId }, { availableStock: { gt: 0 } }] } };
            if (creditNote) {
                f = { where: { ["and"]: [{ productId: res?.productId }, { soldQuantity: { gt: 0 } }] } };
            }
            const response = await getRequest(`${process.env.REACT_APP_API_URL}/product-batch-numbers/byProduct/${res?.productId}?filter=${encodeURIComponent(JSON.stringify(f))}`);

            const data = response.data;
            let val = [];

            if (data && data.filter(el => el.locationId === res?.locationId).length) {
                val = data.filter(el => el.locationId === res?.locationId).map(item => ({
                    ...item,
                    availableStock: creditNote ? -item.soldQuantity : item.availableStock,
                    fakeAvailableStock: creditNote ? -item.soldQuantity : item.availableStock,
                    soldQuantity: 0,
                    originalSoldQuantity: 0
                }));
                setViewBatch(true);
            } else {
                val = [];
                setViewBatch(false);
            }

            setBatch(val);
            handleBulkClick(true, res, val, selected)
            setAutoMark(false);
            return val;
        } catch (error) {
            setViewBatch(false);
            setBatch([]);
            setAutoMark(false);
            return [];
        }
    }

    const handleBulkClick = (value, form, batch, selected) => {
        if (batch?.length) {
            batch.map((el, i) => {
                el.soldQuantity = 0;
                el.originalSoldQuantity = 0;
                batch.splice(i, 1, el);
            })
        }

        if (value) {
            if (creditNote) {
                setBatch(findCombinationCredit(batch, form?.quantity).updatedItems);
                setSelectedBatchId(findCombinationCredit(batch, form?.quantity).changedItems);
            } else {
                setBatch(findCombination(batch, form?.quantity).updatedItems);
                setSelectedBatchId(findCombination(batch, form?.quantity).changedItems);
            }
            let productId = selected.find(el => el.productId === form.productId);
            console.log(selected);
            if (productId) {
                const newTodos = selected.map((el) => {
                    if (el.productId === form.productId && (el.parentLineNumber == null || el.parentLineNumber === "")) {
                        let lie = calculateLineTotal(form);
                        if (batch?.length) {
                            let findCom = findCombination(batch, form?.quantity).changedItems;
                            let findComUpda = findCombination(batch, form?.quantity).updatedItems;
                            if (creditNote) {
                                findCom = findCombinationCredit(batch, form?.quantity).changedItems;
                                findComUpda = findCombinationCredit(batch, form?.quantity).updatedItems;
                            }
                            let batchDetails = [];
                            if (findCom?.length > 0) {
                                let seBatch = findComUpda.filter(el => findCom.includes(el.id));
                                seBatch && seBatch?.length > 0 && seBatch.map((el) => {
                                    batchDetails.push({
                                        batchId: el.id,
                                        batch: el,
                                        quantity: el?.soldQuantity,
                                        discountAmount: el.discountAmount
                                    })
                                })
                            }
                            lie = {
                                ...calculateLineTotal(form),
                                batchDetails: batchDetails
                            };
                        }
                        return { ...el, ...lie };
                    }
                    return el;
                });
                setSelected(newTodos);
            } else {
                setSelected((prevState) => {
                    let lie = calculateLineTotal(form);
                    if (batch?.length) {
                        let findCom = findCombination(batch, form?.quantity).changedItems;
                        let findComUpda = findCombination(batch, form?.quantity).updatedItems;
                        if (creditNote) {
                            findCom = findCombinationCredit(batch, form?.quantity).changedItems;
                            findComUpda = findCombinationCredit(batch, form?.quantity).updatedItems;
                        }
                        let batchDetails = [];
                        if (findCom?.length > 0) {
                            let seBatch = findComUpda.filter(el => findCom.includes(el.id));
                            seBatch && seBatch?.length > 0 && seBatch.map((el) => {
                                batchDetails.push({
                                    batchId: el.id,
                                    batch: el,
                                    quantity: el?.soldQuantity,
                                    discountAmount: el.discountAmount
                                })
                            })
                        }
                        lie = {
                            ...calculateLineTotal(form),
                            batchDetails: batchDetails
                        };
                    }
                    return [...prevState, lie];
                });
            }
        } else {
            const newBatch = batch.map(el => {
                return { ...el, soldQuantity: el.originalSoldQuantity };
            });
            setBatch(newBatch);
            setSelectedBatchId([]);
        }
    }

    const findCombinationCredit = (items, quantity) => {
        let updatedItems = items.map(item => ({ ...item }));
        let changedItems = [];

        for (let item of updatedItems) {
            if (quantity > 0) break;

            let sellQty = Math.max((item?.availableStock || 0), quantity);
            if (sellQty < 0) {
                item.soldQuantity -= sellQty;
                quantity += sellQty;
                item.soldQuantity = -item.soldQuantity;
                changedItems.push(item.id); // Collect updated item
            }
        }

        return { updatedItems, changedItems };
    }

    const findCombination = (items, quantity) => {
        let updatedItems = items.map(item => ({ ...item }));
        let changedItems = [];
        for (let item of updatedItems) {
            if (quantity <= 0) break;

            let sellQty = Math.min((item?.availableStock || 0), quantity);
            if (sellQty > 0) {
                item.soldQuantity += parseFloat(sellQty);
                quantity -= sellQty;
                changedItems.push(item.id); // Collect updated item
            }
        }

        return { updatedItems, changedItems };
    }

    const handleProductBatchDetails = async (data, selected) => {
        let batch = [];
        if (data?.productId) {
            batch = await getProductBatch({ ...data }, selected);
            getAvailableQty(data?.productId, data?.unitId, data?.locationId, batch);
        }

        if (data?.batchDetails && data?.batchDetails?.length > 0) {
            setBatchDetails(data?.batchDetails);
            let a = [];
            data?.batchDetails?.map((el) => {
                a.push(el.batchId);
            });
            let updatedBatches = batch.map(batch => {
                const saleBatch = data?.batchDetails.find(s => s.batchId === batch.id);
                return {
                    ...batch,
                    batch: batch,
                    soldQuantity: saleBatch ? saleBatch.quantity : batch.soldQuantity
                };
            });

            setViewBatch(true);
            setBatch(updatedBatches);
            setSelectedBatchId(a);
        } else {
            setViewBatch(false);
            setBatch([]);
            setSelectedBatchId([]);
        }
    }

    const getAvailableQty = async (id, unitId, locationId, batch, view = false) => {
        if (!productActions) return true;
        try {
            const response = await getRequest(`${process.env.REACT_APP_API_URL}/stock-on-hands/byProduct/${id}/${unitId}/${locationId}`);
            const data = response.data;
            // let val = [];

            if (data?.length && data[0]?.units?.length) {
                let qty = data[0]?.units.find(obj => obj.hasOwnProperty(unitId))?.[unitId];
                setAvailableQuantity(prev => {
                    return {
                        ...prev,
                        [id]: parseFloat(parseFloat(qty).toFixed(2))  // Append `filtered` array
                    };
                });
            } else {
                setAvailableQuantity(prev => {
                    return {
                        ...prev,
                        [id]: 0  // Append `filtered` array
                    };
                });
            }

            if (data?.length && data[0]?.cPrice?.length) {
                let qty = data[0]?.cPrice.find(obj => obj.hasOwnProperty(unitId))?.[unitId];
                setLineForm(prev => ({
                    ...prev,
                    costPrice: parseFloat(parseFloat(qty).toFixed(2))
                }));
            } else {
                setLineForm(prev => ({
                    ...prev,
                    costPrice: 0
                }));
            }

            if (data?.length && data[0]?.cUnits?.length) {
                let qty = data[0]?.cUnits.find(obj => obj.hasOwnProperty(unitId))?.[unitId];

                if (view) {
                    let a = [];
                    batch.map((el, i) => {
                        el.availableStock = qty * el.fakeAvailableStock;
                        el.soldQuantity = view ? 0 : el.soldQuantity;
                        el.originalSoldQuantity = view ? 0 : el.originalSoldQuantity;
                        a.push(el);
                    });
                    setBatch(a);
                    setSelectedBatchId([]);
                }
            }
        } catch (error) {
            console.log(error);
        }
    }


    const handleUnits = (data) => {
        let filter = {
            where: {
                and: [{ productId: data?.id }, { or: [{ unitId: (data?.defaultSalesUnitId || data?.salesUnitId) }, { toUnitId: (data?.defaultSalesUnitId || data?.salesUnitId) },] }]
            }
        }; let uFilter = {
            where: {
                or: [{ unitId: (data?.defaultSalesUnitId || data?.salesUnitId) }, { toUnitId: (data?.defaultSalesUnitId || data?.salesUnitId) }]
            }
        };
        let a = [data?.salesUnitId, data?.skuUnitId, data?.defaultSalesUnitId];

        getRequest(`${process.env.REACT_APP_API_URL}/product-unit-conversions/?filter=${encodeURIComponent(JSON.stringify(filter))}`)
            .then(response => {
                let data = response.data;
                if (data && data.length > 0) {
                    data.forEach(el => {
                        a.push(el.unitId)
                        a.push(el.toUnitId);
                    });
                }
                return getRequest(`${process.env.REACT_APP_API_URL}/unit-conversions/?filter=${encodeURIComponent(JSON.stringify(uFilter))}`);
            }).then(uResponse => {
                let uData = uResponse.data;
                if (uData && uData.length > 0) {
                    uData.forEach(el => {
                        a.push(el.unitId)
                        a.push(el.toUnitId)
                    });
                }

                const filtered = unitMesurementdetails.filter(el => a.includes(el.id));
                setUnits(prev => {
                    return {
                        ...prev,
                        [data?.id]: [...filtered]  // Append `filtered` array
                    };
                });
            })
            .catch(error => {
                console.error("Error fetching data", error);
            });
    }

    const handleBatchClick = (id, form) => {
        const isSelected = selectedBatchId.includes(id);
        let newSelected;

        if (!isSelected) {
            // Checked (select)
            newSelected = [...selectedBatchId, id];

        } else {
            // UnChecked (deselect)
            newSelected = selectedBatchId.filter(batchId => batchId !== id);
        }

        // if (updateSoldQty(newSelected, id, !isSelected, form)) {
        //     setSelectedBatchId(newSelected);
        // } else {

        // }

        if (!creditNote && updateSoldQty(newSelected, id, !isSelected, form)) {
            setSelectedBatchId(newSelected);
        } else if (creditNote && updateSoldQtyCredit(newSelected, id, !isSelected, form)) {
            setSelectedBatchId(newSelected);
        }
    };

    const updateSoldQtyCredit = (newSelected, id, isChecked, form) => {
        const limit = parseFloat(form?.quantity); // Ex: -20

        // Get total sold quantity from selected batches
        const selectedBatches = batch.filter(el => newSelected.includes(el.id));
        const totalSoldQty = selectedBatches.reduce(
            (sum, el) => sum + parseFloat(el?.soldQuantity || 0),
            0
        );


        if (totalSoldQty > limit) {
            const remainingQty = limit - totalSoldQty; // Ex: -20 - (-10) = -10

            const newBatch = batch.map(el => {
                if (el.id === id) {
                    if (isChecked) {
                        const available = parseFloat(el?.availableStock || 0); // negative
                        const assignQty = Math.max(available, remainingQty); // most negative value
                        return { ...el, soldQuantity: assignQty };
                    } else {
                        return { ...el, soldQuantity: el.originalSoldQuantity };
                    }
                }
                return el;
            });

            const newSelectedd = selected.map((el) => {
                if (el.productId === form.productId && (el.parentLineNumber == null || el.parentLineNumber === "")) {
                    let batchDetails = [];
                    if (newSelected.length) {
                        let seBatch = newBatch.filter(el => newSelected.includes(el.id));
                        seBatch && seBatch?.length > 0 && seBatch.map((el) => {
                            batchDetails.push({
                                batchId: el.id,
                                batch: el,
                                quantity: el.soldQuantity,
                                discountAmount: el.discountAmount
                            })
                        })
                    }
                    let lie = {
                        ...calculateLineTotal(form),
                        batchDetails: batchDetails
                    };
                    return { ...el, ...lie };
                }
                return el;
            });

            setSelected(newSelectedd);
            setBatch(newBatch);
            return true;
        }

        // Limit reached or exceeded
        return false;
    };

    const changeHandlerBatch = (data, e, name) => {
        const newTodos = batch.map((el) => {
            if (el.batchNumber === data.batchNumber) {
                return { ...el, [name]: e };
            }
            return el;
        });
        setBatch(newTodos);
    }

    const handleDisplayChange = (val) => {
        storageSetItem('billProductView', val);
        setShowNameDesc(val);
    }

    const updateSoldQty = (newSelected, id, isChecked, form) => {
        let fBatch = batch.filter(el => newSelected.includes(el.id));
        let sQuantity = fBatch.reduce((a, v) => a = parseFloat(a) + parseFloat(v?.soldQuantity || 0), 0);
        if (sQuantity < Math.abs(form?.quantity)) {
            let qty = Math.abs(form?.quantity) - sQuantity;
            const newBatch = batch.map(el => {
                if (el.id === id) {
                    if (isChecked) {
                        // Checked: add availableQty
                        return { ...el, soldQuantity: el.availableStock < qty ? ((el?.soldQuantity || 0) + (el?.availableStock || 0)) : qty };
                    } else {
                        // UnChecked: revert to originalSoldQty
                        return { ...el, soldQuantity: el.originalSoldQuantity };
                    }
                }
                return el;
            });

            const newSelectedd = selected.map((el) => {
                if (el.productId === form.productId && (el.parentLineNumber == null || el.parentLineNumber === "")) {
                    let batchDetails = [];
                    if (newSelected.length) {
                        let seBatch = newBatch.filter(el => newSelected.includes(el.id));
                        seBatch && seBatch?.length > 0 && seBatch.map((el) => {
                            batchDetails.push({
                                batchId: el.id,
                                batch: el,
                                quantity: el.soldQuantity,
                                discountAmount: el.discountAmount
                            })
                        })
                    }
                    let lie = {
                        ...calculateLineTotal(form),
                        batchDetails: batchDetails
                    };
                    return { ...el, ...lie };
                }
                return el;
            });

            setSelected(newSelectedd);
            setBatch(newBatch);
            return true;
        }
        return false
    };

    const changeHandlerLine = async (data, e, name = '', relation = '') => {
        let newTodos = [];

        for (const el of selected) {
            if (el.productId === data.productId && (el.parentLineNumber == null || el.parentLineNumber === "")) {
                let o = {};
                if (order) {
                    o.changed = true;
                }

                if (relation) {
                    const updatedLine = { ...data, [name]: e.id, [relation]: e };
                    setLineForm(updatedLine);

                    if (name === 'unitId') {
                        getAvailableQty(updatedLine.productId, e.id, updatedLine.locationId, batch, true);
                        handleSinglePrice(updatedLine, productPrices);
                        handleStockUnits(updatedLine?.productId, e.id, Math.abs(updatedLine?.quantity));
                    }

                    if (name === 'locationId') {
                        const batchData = await getProductBatch(updatedLine, selected);
                        getAvailableQty(updatedLine.productId, updatedLine.unitId, e.id, batchData, true);
                    }

                    newTodos.push({ ...el, [name]: e.id, [relation]: e, ...o });
                } else {
                    if (name === 'pricePerUnit') {
                        if (lineForm?.unitId === lineForm?.productUnitId) {
                            if (lineForm?.useMrp && lineForm?.maxRetailPrice !== '' && parseFloat(lineForm?.maxRetailPrice) < parseFloat(e)) {
                                toast.dismiss();
                                toast.warning('Unit price is greater than MRP Price');
                            }
                        }
                    }

                    if (name === 'discountRate') {
                        if (lineForm?.discountType === 'perUnit') {
                            let va = lineForm?.quantity < 0 ? 0 : lineForm?.quantity;
                            data['discountAmount'] = parseFloat((parseFloat(e) * parseFloat(va)).toFixed(2));
                        }
                    }

                    const updatedLine = { ...data, [name]: e };
                    setLineForm(updatedLine);

                    newTodos.push({ ...el, [name]: e, ...o });
                }
            } else {
                newTodos.push(el);
            }
        }

        if (name === 'quantity' && e && e !== '') {
            if (productActions) {
                if (priceRef.current !== null) {
                    clearTimeout(priceRef.current);
                }
                priceRef.current = setTimeout(() => {
                    priceRef.current = null;
                    setProductId(data.productId);
                    dispatch({
                        type: productActions.PRODUCT_PRICE_START,
                        url: `/saledprice/${customerId}/${data.productId}/${Math.abs(e)}`
                    });
                    handleStockUnits(data?.productId, data.unitId, Math.abs(e));
                    checkFreeProduct(lineForm?.productId, Math.abs(e), lineForm?.locationId);
                }, 1000);
            }
        }
        setSelected(newTodos);
        setChangeSelected(!changeSelected);
    };

    const handleQuantityChange = (data, v) => {
        let newTodos = [];

        if (lineForm?.productId && !checkLineForm(lineForm)) {
            toast.dismiss();
            toast.error('Please select value in the highlighted mandatory field');
            return false;
        }

        if (v === 'decrease') {
            if (data.quantity === 1) {
                setSelected(prevState => {
                    setLineForm(prevState.filter((el, i) => el.productId !== data.productId)[prevState.filter((el, i) => el.productId !== data.productId).length - 1]);
                    return prevState.filter((el, i) => el.productId !== data.productId)
                });
                return true;
            } else {
                newTodos = selected.map((el) => {
                    if (el.productId === data.productId && (el.parentLineNumber == null || el.parentLineNumber === "")) {
                        if (productActions) {
                            if (priceRef.current !== null) {
                                clearTimeout(priceRef.current);
                            }
                            priceRef.current = setTimeout(() => {
                                priceRef.current = null;
                                setProductId(data.productId);
                                dispatch({
                                    type: productActions.PRODUCT_PRICE_START,
                                    url: `/saledprice/${customerId}/${data.productId}/${Math.abs(parseInt(el.quantity) - parseInt(1))}`
                                });
                                handleStockUnits(lineForm?.productId, lineForm.unitId, Math.abs(parseInt(el.quantity) - parseInt(1)));
                                checkFreeProduct(lineForm?.productId, Math.abs(parseInt(el.quantity) - parseInt(1)), lineForm?.locationId);
                            }, 1000);
                        }
                        setLineForm({ ...el, 'quantity': parseInt(el.quantity) - parseInt(1) });
                        return { ...el, 'quantity': parseInt(el.quantity) - parseInt(1) };
                    }
                    return el;
                });
            }
        } else {
            if (data.quantity === -1) {
                setSelected(prevState => {
                    setLineForm(prevState.filter((el, i) => el.productId !== data.productId)[prevState.filter((el, i) => el.productId !== data.productId).length - 1]);
                    return prevState.filter((el, i) => el.productId !== data.productId)
                });
                return true;
            } else {
                newTodos = selected.map((el) => {
                    if (el.productId === data.productId && (el.parentLineNumber == null || el.parentLineNumber === "")) {
                        if (productActions) {
                            if (priceRef.current !== null) {
                                clearTimeout(priceRef.current);
                            }
                            priceRef.current = setTimeout(() => {
                                priceRef.current = null;
                                setProductId(data.productId);
                                dispatch({
                                    type: productActions.PRODUCT_PRICE_START,
                                    url: `/saledprice/${customerId}/${data.productId}/${Math.abs(parseInt(el.quantity) + parseInt(1))}`
                                });
                                handleStockUnits(lineForm?.productId, lineForm.unitId, Math.abs(parseInt(el.quantity) + parseInt(1)));
                                checkFreeProduct(lineForm?.productId, Math.abs(parseInt(el.quantity) + parseInt(1)), lineForm?.locationId);
                            }, 1000);
                        }
                        setLineForm({ ...el, 'quantity': parseInt(el.quantity) + parseInt(1) });
                        return { ...el, 'quantity': parseInt(el.quantity) + parseInt(1) };
                    }
                    return el;
                });
            }
        }
        hsnApi('', data.hsnId);
        setSelected(newTodos);
        setChangeSelected(!changeSelected);
    }

    useEffect(() => {
        if (triggerLineSubmit) {
            callBackLineSubmit();
        }
    }, [triggerLineSubmit]);

    const handleLineSubmit = () => {
        if (!checkLineForm(lineForm)) {
            toast.dismiss();
            toast.error('Please select value in the highlighted mandatory field');
            return false;
        }

        setTriggerLineSubmit(true);
    }


    const callBackLineSubmit = () => {
        if (!selected || selected.length === 0) {
            lineSubmit([]);
            return;
        }

        const cleanedLines = selected.map((item) => {
            const element = { ...item };

            // ❌ Remove unwanted keys
            delete element.discountCalcAmount;
            delete element.useMrp;
            delete element.productUnitId;
            delete element.discountPercAmount;
            delete element.location;
            delete element.costPrice;

            // 📦 Stock update logic
            const stockData = lineStock?.[element.productId];

            element.stockQuantity = stockData?.quantity ?? null;
            element.stockUnitId = stockData?.unitId ?? null;
            element.stockUnit = stockData?.unit ?? null;

            // 🧾 Batch details
            if (Array.isArray(element.batchDetails) && element.batchDetails.length > 0) {
                element.batchDetails = element.batchDetails.map(batch => ({ ...batch }));
            }

            // 🧹 Quote-specific cleanup
            if (quote) {
                // delete element.locationId;
                delete element.batchDetails;
            }

            return element;
        });

        lineSubmit(cleanedLines);
    };

    const handleTypeChange = (value) => {
        setType(value);
        dispatchFilter(value, productGroupId);
    }

    const handleLineForm = (type, val) => {
        const selectedFileter = selected.filter(el => el.parentLineNumber == null || el.parentLineNumber === "");
        const index = selectedFileter.findIndex((a) => a.productId === val);
        if (index >= 0) {
            let d = '';
            if (type === 'prev') {
                setLineForm(selectedFileter[index - 1]);
                d = selectedFileter[index - 1];
            } else {
                setLineForm(selectedFileter[index + 1]);
                d = selectedFileter[index + 1];
            }
            handleProductBatchDetails(d, selectedFileter);
            if (d?.hsnId) {
                hsnApi('', d.hsnId);
            }
            handleStockUnits(d.productId, d.unitId, d.quantity);
            handleUnits(d.product);
            checkFreeProduct(d.productId, d.quantity, d.locationId);
        }
    }

    const handleGroupChange = (v) => {
        setProductGroupId(v);
        dispatchFilter(type, v);
    }

    const changeSearchType = (value) => {
        storageSetItem('productSearch', value);
        dispatchFilter(type, productGroupId);
    }

    return (
        <PrimaryDrawer
            anchor={'right'}
            open={visible}
            variant={'temporary'}
            handleClose={() => handleClose()}
            width={productActions ? (selected.length ? '1000px' : '650px') : '690px'}
            title={'Add Sales Lines'}
            className={clsx(classes.closeBackGround, classes.width100PCustomerandSales)}
            component={
                <div className={clsx(classes.customForm, classes.customFormProducts, classes.removeUnderline, extraClass)}>
                    <div className={clsx(classes.customFormLeft, { [classes.customFormLeftSel]: selected.length > 0 && productActions })}>
                        <div className={clsx(classes.customFormFlex, classes.customFormFlexProducts, { [classes.customFormFlexGrid]: selected.length > 0 })}>
                            {
                                type === 'myProducts' && <Row>
                                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                        <div style={{ marginBottom: 10 }} className={clsx(classes.dropDownWithSearch, classes.customerLabelNone)}>
                                            <AutoCompleteComponent
                                                customLabel={"Type"}
                                                heads={[{ 'key': 'label', 'name': 'Search Configuration' }]}
                                                details={[{ id: 'name', label: "Name" }, { id: 'code', label: "Code" }, { id: 'both', label: "Both" }, { id: 'standard', label: "Standard" }, { id: 'mrp', label: "MRP" }]}
                                                parentValue={customObject([{ id: 'name', label: "Name" }, { id: 'code', label: "Code" }, { id: 'both', label: "Both" }, { id: 'standard', label: "Standard" }, { id: 'mrp', label: "MRP" }], checkProductSearch())}
                                                position={"bottom"}
                                                variant={'outlined'}
                                                onChange={(data) => changeSearchType(data.id)}
                                            />
                                            <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                                <TextField autoComplete='one-time-code'
                                                    placeholder={
                                                        checkProductSearch() === 'standard' ? 'Search Name, ID, Bar Code, and Code' :
                                                            checkProductSearch() === 'both' ? 'Search Name, and Code' :
                                                                checkProductSearch() === 'name' ? 'Search Name' :
                                                                    checkProductSearch() === 'code' ? 'Search Code' :
                                                                        checkProductSearch() === 'mrp' ? 'Search MRP' : ''
                                                    }
                                                    value={search}
                                                    type='search'
                                                    variant={'standard'}
                                                    onChange={(e) => setSearch(e.target.value)}
                                                    fullWidth
                                                    onFocus={() => setIconAnimation(true)}
                                                    onBlur={() => setIconAnimation(false)}
                                                />
                                                <Image src={SearchIcon} preview={false} />
                                                {
                                                    search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                        <Image
                                                            src={ClearIcon}
                                                            preview={false}
                                                        />
                                                    </NavLink>
                                                }
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            }
                            <Row style={{ height: type !== 'myProducts' ? "100%" : "calc(100% - 45px)" }}>
                                <Col span={16} className={clsx(classes.prod_group)} style={{ height: "calc(100% - 32px)" }}>
                                    <FormControl
                                        style={{ marginBottom: 10 }}
                                        className={clsx(classes.dropDownPointer, classes.customRadioButton, classes.PadLR15)}
                                        variant={'standard'}
                                        fullWidth>
                                        <RadioGroup
                                            row
                                            value={type}
                                            onChange={(e) => handleTypeChange(e.target.value)}>
                                            {
                                                viewType ? '' : <FormControlLabel value="customerProducts" disabled={customerProducts} control={<Radio
                                                    checkedIcon={<UnSelectedIcon />}
                                                    icon={<SelectedIcon />}
                                                />} label="Customer Products" />
                                            }
                                            <FormControlLabel value="myProducts" control={<Radio
                                                checkedIcon={<UnSelectedIcon />}
                                                icon={<SelectedIcon />}
                                            />} label="My Products" />
                                        </RadioGroup>
                                    </FormControl>

                                    {/* <GridView
                                        {...props}
                                        type={type}
                                        loadTasks={() => dispatchFilter(type)}
                                        details={getList}
                                        loadMore={loadMore}
                                        salesType={creditNote ? 'Sale Return' : 'Sales'}
                                        loadMoreContent={loadMoreContent}
                                        loadMoreTask={() => loadMoreTask()}
                                        classes={classes}
                                        clsx={clsx}
                                        selected={selected}
                                        productId={productId}
                                        errorLineForm={errorLineForm}
                                        handleQuantityChange={(data, v) => handleQuantityChange(data, v)}
                                        changeHandlerLine={(data, e, name = '', relation = '') => changeHandlerLine(data, e, name, relation)}
                                        handleGridClick={(data, dataPro) => handleClick(data, dataPro)}
                                        visible={formVisible}
                                        handleClose={(v) => setFormVisible(v)}
                                        lineError={lineError}
                                        form={lineForm}
                                    /> */}
                                    <GridViewNew
                                        {...props}
                                        type={type}
                                        loadTasks={() => dispatchFilter(type)}
                                        details={getList}
                                        loadMore={loadMore}
                                        salesType={creditNote ? 'Sale Return' : 'Sales'}
                                        loadMoreContent={loadMoreContent}
                                        loadMoreTask={() => loadMoreTask()}
                                        classes={classes}
                                        clsx={clsx}
                                        selected={selected}
                                        productId={productId}
                                        errorLineForm={errorLineForm}
                                        handleQuantityChange={(data, v) => handleQuantityChange(data, v)}
                                        changeHandlerLine={(data, e, name = '', relation = '') => changeHandlerLine(data, e, name, relation)}
                                        handleGridClick={(data, dataPro) => handleClick(data, dataPro)}
                                        visible={formVisible}
                                        handleClose={(v) => setFormVisible(v)}
                                        lineError={lineError}
                                        form={lineForm}
                                        showNameDesc={showNameDesc}
                                        stockLoading={stockLoading}
                                    />
                                </Col>
                                <Col span={8} style={{ padding: "0px 0px 0px 10px", height: "calc(100% - 30px)" }}>
                                    <FormControl
                                        style={{ marginBottom: 10 }}
                                        className={clsx(classes.dropDownPointer, classes.customRadioButton, classes.PadLR15)}
                                        variant={'standard'}
                                        fullWidth>
                                        <RadioGroup
                                            row
                                            value={showNameDesc}
                                            onChange={(e) => handleDisplayChange(e.target.value)}>
                                            <FormControlLabel value="name" control={<Radio
                                                checkedIcon={<UnSelectedIcon />}
                                                icon={<SelectedIcon />}
                                            />} label="Name" />
                                            <FormControlLabel value="description" control={<Radio
                                                checkedIcon={<UnSelectedIcon />}
                                                icon={<SelectedIcon />}
                                            />} label="Description" />
                                        </RadioGroup>
                                    </FormControl>
                                    <div className={clsx(classes.heightFull, { [classes.disabled]: type === 'customerProducts' })} style={{ overflow: "auto", marginRight: "-10px", paddingRight: 10, paddingBottom: 5 }}>
                                        <NavLink to={'#'} onClick={() => handleGroupChange('')} className={clsx(classes.listprod, { [classes.listprodactive]: productGroupId === '' })}>All Products</NavLink>
                                        {
                                            productGroupDetails && productGroupDetails?.map((el, i) => (
                                                <NavLink to={'#'} onClick={() => handleGroupChange(el.id)} key={i} className={clsx(classes.listprod, { [classes.listprodactive]: productGroupId === el.id })}>{showNameDesc === 'name' ? el.name : (el?.description || '---')}</NavLink>
                                            ))
                                        }
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Space direction="horizontal" align="center" size={[10, 10]}>
                                <Button
                                    key="Add"
                                    color='primary'
                                    variant="contained"
                                    onClick={() => handleLineSubmit()}
                                    id={idNamingConversion('Add', 'salesBillLines', 'Button')}
                                    className={clsx(classes.modalBtn)}>
                                    Add
                                </Button>
                            </Space>
                        </div>
                    </div>
                    <div className={clsx(classes.customFormRight, { [classes.customFormRightSel]: selected.length > 0 && productActions })}>
                        <BillLineForm
                            {...props}
                            visible={visible}
                            form={lineForm}
                            parentForm={{ includeGst: includeGst }}
                            error={lineError}
                            salesType={creditNote ? 'Sale Return' : 'Sales'}
                            view={false}
                            productGstdetails={productGstdetails}
                            unitMesurementdetails={unitMesurementdetails}
                            hsnDetails={hsnDetails}
                            classes={classes}
                            handleClose={() => handleClose(false)}
                            customObject={(details, id) => customObject(details, id)}
                            changeHandlerLine={(e, name = '', relation = '') => changeHandlerLine(lineForm, e, name, relation)}
                            handleLineSubmit={(e) => handleLineSubmit(e)}
                            hsnApi={(s) => hsnApi(s)}
                            handleLineForm={(type, val) => handleLineForm(type, val)}
                            selected={selected}
                            purchase={false}
                            viewBatch={viewBatch}
                            batch={batch}
                            handleViewBatch={(d) => setViewBatch(d)}
                            selectedBatchId={selectedBatchId}
                            handleBulkClick={(v, form, batch, selected) => handleBulkClick(v, form, batch, selected)}
                            handleClick={(id, form) => handleBatchClick(id, form)}
                            setBatch={(d) => setBatch(d)}
                            autoMark={autoMark}
                            setAutoMark={(d) => setAutoMark(d)}
                            changeHandlerBatch={(data, value, name) => changeHandlerBatch(data, value, name)}
                            availableQuantity={availableQuantity}
                            units={units}
                            parameterDetails={parameterDetails}
                            showNameDesc={showNameDesc}
                            setShowFreeProduct={() => setShowFreeProduct(!showFreeProduct)}
                            showFreeProduct={showFreeProduct}
                            freeProduct={freeProduct}
                            freeAvailableQuantity={freeAvailableQuantity}
                            lineStock={lineStock}
                        />
                    </div>
                </div>
            }
        />
    )
}